module.exports = __webpack_public_path__ + "static/media/rightSlogan.e6987d8b.png";